import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const ProductsServices = createApi({
	reducerPath: "ProductsServices",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			allProducts: builder.query({
				query: (data) => {
					return {
						url: `vehicles?search=${
							data?.search ? data?.search : ""
						}&category_id=${data?.cate ? data?.cate : ""}&brand_id=${
							data?.brands ? data?.brands : ""
						}`,
						method: "GET",
					};
				},
			}),
			productsGetById: builder.query({
				query: (id) => {
					return {
						url: `vehicles/show/${id}`,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useAllProductsQuery, useProductsGetByIdQuery } =
	ProductsServices;
export default ProductsServices;
